import { useTranslation } from "react-i18next";
import { ErrorBlock } from "antd-mobile";

/**
 * 1005:企微 H5 在普通浏览器打开时的统一说明(不发授权请求、不出「授权失败」)。
 * 员工练习(wecom-h5)与经营军师(advisor-h5)共用;description 缺省 = 员工练习那句。
 */
export function NotInWeComNotice({ description }: { description?: string }) {
  const { t } = useTranslation("coaching");
  return (
    <div className="flex-1 flex items-center justify-center px-6" data-testid="not-in-wecom-notice">
      <ErrorBlock
        status="default"
        title={t("wecomAuth.notInWeComTitle")}
        description={description ?? t("wecomAuth.notInWeComDesc")}
      />
    </div>
  );
}
